import { API } from "@lib/services/http";
import {
  ITelegramBotCrmRequest,
  ITelegramBotDialogueRequest,
  TTelegramBotDialogueRow,
} from "@lib/types/TelegramChatBot";

const dialoguePath = "telegram-bot-dialogue";

export function getAllTelegramBotDialogue(
  dialogueRequest: ITelegramBotDialogueRequest,
) {
  const { requireAuth, configId } = dialogueRequest;
  const data: ITelegramBotCrmRequest = {
    method: "GET",
    path: `${dialoguePath}/dialogues-with-children`,
    params: `configId=${configId}&requireAuth=${requireAuth}`,
  };

  return API.post<TTelegramBotDialogueRow[]>(`telegram-bot-resource`, data);
}

export function createOneTelegramBotDialogue(
  value: Partial<TTelegramBotDialogueRow>,
) {
  const data: ITelegramBotCrmRequest = {
    method: "POST",
    path: dialoguePath,
    data: value,
  };

  return telegramBotResource(data);
}

export function updateOneTelegramBotDialogue(
  dialogue: Partial<TTelegramBotDialogueRow>,
) {
  const data: ITelegramBotCrmRequest = {
    method: "PATCH",
    path: `${dialoguePath}/${dialogue.id}`,
    data: dialogue,
  };

  return telegramBotResource(data);
}

export function deleteOneTelegramBotDialogue(id: string) {
  const data: ITelegramBotCrmRequest = {
    method: "DELETE",
    path: `${dialoguePath}/${id}`,
  };

  return telegramBotResource(data);
}

export function telegramBotResource(data: ITelegramBotCrmRequest) {
  return API.post<TTelegramBotDialogueRow>(`telegram-bot-resource`, data);
}
